// flexinet-users-api
import {stage} from "../../../config/stage";

const usersApi = {
    prod: {
        endpoint: 'https://f42lx6qgonahbclkzlqekvm4le.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    test: {
        endpoint: 'https://2m6swoqvfberhbziynzu7zc4qu.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    dev: {
        endpoint: 'https://ynqjnxb7nja5bgwn7gsxvsiukq.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    ide: {
        endpoint: 'https://ynqjnxb7nja5bgwn7gsxvsiukq.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
};

export const usersApiConfig = usersApi[stage] ?? usersApi.dev;

